import styled from 'styled-components';
import media from '../../../styles/Media.styled';

/**
 * Main container for the ProgressBar component
 * Uses transient props with $ prefix to prevent them from being passed to the DOM
 */
export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${props => props.$margin || '0px 0px 2px 0px'};
    padding: ${props => props.$padding || '20px 24px'};
    position: relative;
    ${'' /* width: calc(100% - 20px); */}
    border-radius: 6px;
    box-shadow: ${props => props.$boxShadow || '0px 0px 6px #00000029'};
    background: ${props => props.$background || '#ffffff 0% 0% no-repeat padding-box'};
      ${media.mobileDevice`
        box-shadow: ${props => props.$boxShadowMb || '0px 0px 6px #00000029'};
        background: ${props => props.$backgroundMb || '#ffffff 0% 0% no-repeat padding-box'};
        margin: ${props => props.$marginMb};
        padding: ${props => props.$paddingMb || '0px'};
    `};
`;